import React from 'react';
import { Svg, ISvg } from '../Svg';

export const MobileDevelopment: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M41.6654 14.1673V35.834C41.6654 44.5006 39.582 46.6673 31.2487 46.6673H18.7487C10.4154 46.6673 8.33203 44.5006 8.33203 35.834V14.1673C8.33203 5.50065 10.4154 3.33398 18.7487 3.33398H31.2487C39.582 3.33398 41.6654 5.50065 41.6654 14.1673Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.332 8.33398H21.6654"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.75 22.9939V27.0009C18.75 28.4731 18.75 28.4731 20.1389 29.4106L23.9583 31.6189C24.5347 31.9523 25.4722 31.9523 26.0417 31.6189L29.8611 29.4106C31.25 28.4731 31.25 28.4731 31.25 27.0078V22.9939C31.25 21.5286 31.25 21.5286 29.8611 20.5911L26.0417 18.3828C25.4722 18.0495 24.5347 18.0495 23.9583 18.3828L20.1389 20.5911C18.75 21.5286 18.75 21.5286 18.75 22.9939Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.0011 27.0846C26.1517 27.0846 27.0844 26.1519 27.0844 25.0013C27.0844 23.8507 26.1517 22.918 25.0011 22.918C23.8505 22.918 22.9178 23.8507 22.9178 25.0013C22.9178 26.1519 23.8505 27.0846 25.0011 27.0846Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
